import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Patient } from "../patients/patient";
import { PatientsService } from "../patients.service";
import { ExamsService } from "../exams.service";
import { LoginService } from "../login.service";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CommerrorService } from "../commerror.service";
import { PregnancyService } from "../pregnancy.service";
import { GastroFormsService } from "../gastro-forms.service";
import { DiagnosisService } from "../diagnosis.service";
import { CalendarService } from "../calendar.service";
import { SitesService } from "../sites.service";

@Component({
    selector: "app-patexams",
    templateUrl: "./patexams.component.html",
    styleUrls: ["./patexams.component.scss"],
    standalone: false
})
export class PatexamsComponent implements OnInit, OnDestroy {
  @ViewChild("inputTitle")
  set inputTitle(element: ElementRef<HTMLInputElement>) {
    if (element) {
      element.nativeElement.focus();
    }
  }
  inform = false;
  showComment = false;
  selectedForm;
  calendarForm: boolean = false;
  pat: Patient;
  showPat: boolean = false;
  pregnancies: any = null;
  etype: string = "Eyes";
  typeForm = false;
  examname: string;
  concentForm;
  otherExams: any;
  formsExams: any[] = [];
  calendarForms: any[] = [];
  notFormExams: any[] = [];
  ecgExams: any[] = [];
  gastroForms: any[] = [];
  gastroVisits: any[] = [];
  gastroExams: any[] = [];
  letters: any;
  showLogin = false;
  AWLAlreadyExists = false;
  private destroy$ = new Subject();
  public examsLoaded$ = new Subject();
  toDelete;
  readydelete = false;
  goEx;
  newExam = true;
  closePreg: number = null;
  pregExams;
  defaults;
  startClinic: number;
  openAWL = false;
  subscription = new Subscription();
  FORMS = ["Consultation Letter", "Inform Consent"];
  ECG = ["Resting ECG", "Ergometry", "Stress", "Holter ECG"];
  CARDIO = ["TTE Adults", "TTE Pediatric", "Duplex Carotid", "Stress-Echo"];
  EYES = ["FOV", "OCT", "Pachymetry"];
  INVASIVE = ["Amniocentesis", "CVS"];

  GastroForms = ["Admission Form", "Time Out Form"];
  gastroExamsChanged = new Subject();
  fanciness = "simple";
  showSendQuestionnaire = false;
  sendQuestionnairePatient: any = null;
  patientQuestionnaires: any[] = [];

  constructor(
    public ce: CommerrorService,
    public gfs: GastroFormsService,
    public patService: PatientsService,
    public ps: PregnancyService,
    public examServe: ExamsService,
    public login: LoginService,
    public ds: DiagnosisService,
    public cf: CalendarService,
    private http: HttpClient,
    public sites: SitesService,
  ) {}

  redirectAdministration(type) {
    this.http.post("/api/administration", { type }).subscribe((data: string) => {
      window.location.href = data + "/" + this.patService.currentPatient.PID;
    });
  }

  ngOnInit() {
    this.login.loginMissing();
    try {
      this.pat = this.patService.getPat();
      //this.pat.asignVals(history.state.data);
    } catch {}

    if (this.login.category.name == "forms") {
      this.etype = "Forms";
    }
    if (this.pat.ID != "default") {
      this.resetPregs();
    } else {
      //defaults
      this.examServe.getDefaults().subscribe(
        (data) => {
          this.defaults = [];
          for (let i = 0; i < data["length"]; i++)
            this.defaults[data[i]["ExamType"]] = data[i];
        },
        (error) => {
          console.error(error);
        },
      );
    }
    this.subscription = this.patService.lettersChange.subscribe((response) => {
      this.letters = response;
    });
    this.subscription = this.cf.caldeleted$.subscribe((data) => {
      this.resetPregs();
    });
    if (!this.login.isCardio && this.pat.ID === "default")
      this.examServe.getCustomTitles();
  }

  loadQuestionnaires() {
    if (
      !this.pat ||
      this.pat.ID === "default" ||
      this.pat.PID == null ||
      !(this.login.premissions && this.login.premissions.Questionnaires)
    )
      return;
    this.examServe
      .getPatientQuestionnaires(this.pat.PID)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data: any) => {
          this.patientQuestionnaires = (data && data.items) || [];
        },
        (error) => {
          console.error(error);
        },
      );
  }

  openQuestionnairePdf(q: any) {
    if (q && q.answeredDate && q.code)
      window.open("api/questionnaires/pdf/" + q.code);
  }

  resetPregs() {
    this.loadQuestionnaires();
    this.examServe
      .getExams(this.pat.PID.toString())
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.pregnancies = data["pregnancies"];
          this.examServe.pregnancies = data["pregnancies"];
          for (let item of this.pregnancies) {
            this.examServe
              .getAllCalForms(item.AutoIndex)
              .pipe(takeUntil(this.destroy$))
              .subscribe((data) => {
                if (data[0].calendar.length > 0)
                  item.calendarForms.push(data[0].calendar[0]);
                if (data[0].concent.length > 0) item.forms = data[0].concent;
                // for(let concentForm of data[0].concent)
                // item.forms.push(concentForm)
              });
            // this.examServe.getConcentForms(item.AutoIndex).subscribe((data) => {
            //   if(data[0])
            //     item.forms.push(data[0])
            // })
          }

          if (
            this.pregnancies &&
            this.pregnancies.length > 0 &&
            this.pregnancies[0].LMP
          )
            this.pat.LMP = this.pregnancies[0].LMP;
          // this.letters = this.patService.getConsultationLetter(this.pat);
          this.otherExams = data["other"];
          if (this.otherExams.length > 0) {
            this.otherExams.forEach((exam) => {
              if (this.FORMS.includes(exam.ExamType)) {
                this.formsExams.push(exam);
              } else {
                this.notFormExams.push(exam);
              }
            });
          }
          if (this.login.isGastro) {
            this.examsLoaded$.next(undefined);
            this.ds.BuildList;
          }
          if (this.pat.AWLID) {
            if (!this.login.isGastro) {
              for (let i = 0; i < this.pregnancies.length; i++) {
                for (let e of this.pregnancies[i]["exams"]) {
                  if (e.AWLID == this.pat.AWLID) {
                    this.AWLAlreadyExists = true;
                    return;
                  }
                }
              }
            }
            for (let e of this.otherExams) {
              if (e.AWLID == this.pat.AWLID) {
                this.AWLAlreadyExists = true;
                return;
              }
            }
          } else {
            if (this.login.isCardio) {
              this.patService.getPatAWL();
            }
          }
        },
        (error) => {
          //add this later
          console.error(error);
        },
      );
    this.subscription = this.examsLoaded$.subscribe(() => {
      var v = this.gfs.getVisits(this.pat.PID);
      v.subscribe((data: any) => {
        this.gastroVisits = data;
        this.gastroVisits.forEach((visit, i) => {
          this.gastroVisits[i]["exams"] = this.gastroExams.filter((exam) => {
            return (
              exam.CreationTime.split("T")[0] == visit.ExamDate.split("T")[0]
            );
          });
          var f = this.gfs.getFormByVisit(visit.AutoIndex);
          f.subscribe((data) => {
            this.gastroVisits[i]["forms"] = data;
          });
        });
        this.gfs.loadForm(false, true, this.gastroVisits[0]["AWLID"]);
      });
    });
    this.login.onLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
      // Sites, last line of defence: never open an exam once the session's
      // clinic and the exam's clinic have drifted apart. goExam() fans out into
      // many independently clinic-scoped calls (patient/exam/print/gallery/
      // DICOM) that each trust the session GID, so a mismatch here surfaces as
      // a 403 'not owner' mid-render with the view already half torn down.
      // goExam is gated up front now and login.js pins re-auth to the session's
      // clinic, so this should be unreachable — it exists so a future ungated
      // path fails loudly and safely instead of corrupting the exam view.
      if (
        this.goEx &&
        this.goEx.exam?.GID &&
        this.login.ClinicID &&
        Number(this.goEx.exam.GID) !== Number(this.login.ClinicID)
      ) {
        this.showLogin = false;
        this.goEx = null;
        this.ce.errorGastro(
          "Wrong Clinic",
          "This exam belongs to another clinic. Switch to that clinic and open it again.",
        );
        return;
      }
      if (this.goEx) {
        this.examServe.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype);
      } else {
        if (
          this.etype == "GastroForms" ||
          this.examname == "Inform Consent" ||
          this.concentForm
        ) {
          this.showLogin = false;

          if (this.etype == "GastroForms") {
            this.typeForm = true;
            this.inform = false;
            var awl = this.pat.AWLID
              ? this.pat.AWLID.toString()
              : this.gastroVisits[0].AutoIndex.toString();
            this.examsLoaded$.next(undefined);
          }
          if (this.examname == "Inform Consent" || this.concentForm)
            this.inform = true;
        } else {
          if (
            this.pregnancies.length > 0 &&
            this.pregnancies[0].forms.filter(
              (i) => i.ExamType == this.examname && !i.ExamID,
            ).length == 0 &&
            !this.login.ishospital &&
            this.login.premissions.Consent
          ) {
            this.inform = true;
            this.showLogin = false;
            this.examServe.openNewExam = true;
          } else {
            if (this.pregnancies.length > 0)
              this.examServe.concentForm = this.pregnancies[0].forms.filter(
                (i) => i.ExamType == this.examname && !i.ExamID,
              )[0];
            this.examServe.startExam(
              this.examname,
              this.pat.PID,
              this.pat.ID,
              this.pat.AWLID,
              this.pat.ExamLMP,
            );
          }
        }
      }
    });
  }

  viewonly() {
    this.examServe.goExam(
      this.goEx.preg,
      this.goEx.exam,
      this.goEx.etype,
      true,
    );
  }
  startForm(form = null) {
    if (this.examname == "Inform Consent" || form) {
      this.examServe.examID = null;
      this.concentForm = form;
      this.showLogin = true;
      this.examServe.openNewExam = false;
    } else {
      this.concentForm = null;
      this.inform = false;
      var today = new Date().toISOString().split("T")[0];
      var checkAwl = true;
      if (this.gastroVisits.length > 0) {
        checkAwl =
          new Date(this.gastroVisits[0].ExamDate.split("T")[0])
            .toISOString()
            .split("T")[0] !== today;
      }
      if (this.GastroForms.includes(this.examname) && checkAwl) {
        return this.ce.errorGastro(
          "Today List Missing",
          "A TodayList has to be generated before a new exam can be opened!",
        );
      }
      this.showLogin = true;
      return;
    }
  }
  goForm(form) {
    this.typeForm = true;
    var isTimeOut = form["FormName"] == "Time Out Form";
    this.gfs.loadForm(isTimeOut, form);
  }

  startExam() {
    if (this.examname === 'Send Questionnaire') { this.openSendQuestionnaireForPatient(); return; }
    var today = new Date().toISOString().split("T")[0];
    this.examServe.examID = null;
    var checkAwl = true;
    let lastAwlDate = this.patService.lastAwlDate
      ? new Date(this.patService.lastAwlDate).toISOString().split("T")[0]
      : null;

    checkAwl = this.patService.getPat().AWLID == null || today !== lastAwlDate;

    // checkAwl = new Date(this.gastroVisits[0].ExamDate.split("T")[0]).toISOString().split("T")[0] !== today

    if (
      this.EYES.includes(this.examname) &&
      checkAwl &&
      this.pat.ID != "default"
    ) {
      return this.ce.errorGastro(
        "Today List Missing",
        "A TodayList has to be generated before a new exam can be opened!",
      );
    }

    if (this.EYES.includes(this.examname) && this.pat.ID != "default") {
      if (
        !this.patService.currentPatient.ExamCode &&
        !this.patService.currentPatient.Status
      )
        return this.ce.errorGastro(
          "Today List",
          "Must enter the patient through the today list",
        );

      if (!this.patService.currentPatient.ExamCode)
        return this.ce.errorGastro(
          "Today List Missing",
          "Must select exam type in Today List",
        );

      let examCode = this.patService.currentPatient.ExamCode.split("+");
      examCode = examCode.map((str) => str.trim());
      let foundMatch = false;
      for (const code of examCode) {
        if (this.examname.includes(code)) {
          foundMatch = true;
          break; // Break if a match is found
        }
      }
      if (!foundMatch) {
        let examsFromTodayList = examCode[0];
        if (examCode.length > 1) examsFromTodayList = "FOV or OCT";
        return this.ce.errorGastro(
          "Today List",
          `Today List only allows ${examsFromTodayList} `,
        );
      }
    }

    if (this.examname === "Inform Consent") {
      return alert("we are working on it! will be available soon");
    }
    if (!this.etype || !this.examname) return;
    if (this.pat.ID != "default") {
      this.concentForm = null;
      this.newExam = true;
      this.showLogin = true;
      return;
      // this.examServe.startExam(this.examname, this.pat.PID, this.pat.ID, this.pat.AWLID, this.pat.ExamLMP);
    } else {
      //default
      if (this.defaults[this.examname]) {
        this.examServe.goExam(
          null,
          this.defaults[this.examname],
          this.examname,
        );
      } else this.examServe.startExam(this.examname, 0, "default");
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  canOpen(): boolean {
    return (
      this.login.canStartExam(this.pat.AWLID != null) &&
      (!this.AWLAlreadyExists || this.login.AWLUnlimited) &&
      (!this.login.separatedClinic ||
        this.login.isAdmin ||
        !this.patService.getPat().UID ||
        this.patService.getPat().UID == this.login.UID ||
        this.patService.getPat()["AWLUID"] == this.login.UID)
    );
  }

  goExam(pregid: number, exam, examtype: string, examtime: string, event?: MouseEvent) {
    if (
      (exam.Locked &&
        exam.LockedBy.toLowerCase() != this.login.loginname.toLowerCase()) ||
      !this.canView(exam)
    )
      return;
    let etime = new Date(examtime);
    var closed;
    if (exam.ClosedDate) closed = new Date(exam.ClosedDate);
    let now = new Date();

    const anchor =
      (event?.currentTarget as HTMLElement) ||
      (event?.target as HTMLElement) ||
      null;

    // Sites: the clinic gate has to run on BOTH exits, before anything else
    // happens. The global switcher may have moved the session since this list
    // loaded, and every clinic-scoped lookup downstream (patient/exam/print/
    // gallery/DICOM) trusts the session GID on its own — so block on a mismatch
    // and require an explicit confirm first.
    //
    // The closed-exam branch used to skip this and go straight to the loginbox,
    // which was the live 403 'not owner': re-auth re-resolved the clinic from
    // scratch server-side and dragged the session to a different one, while the
    // frontend kept its old ClinicID. Gating here means the session is already
    // on exam.GID by the time the loginbox appears, so the re-auth confirms the
    // clinic the doctor is actually working in (see login.js's re-auth pin).
    this.sites.requestOpen(
      exam.GID,
      () => {
        if (
          exam.ClosedDate &&
          (this.login.userType == "doctor" ||
            this.login.userType == "visitingdoc" ||
            this.login.userType == "tech")
        ) {
          this.newExam = false;
          this.showLogin = true;
          this.goEx = { preg: pregid, exam: exam, etype: examtype };
          if (this.login.ClinicID) {
            this.startClinic = this.login.ClinicID;
          }
        } else {
          this.examServe.goExam(pregid, exam, examtype);
        }
      },
      anchor,
    );
  }

  canView(exam) {
    return (
      !this.login.separatedClinic ||
      this.login.isAdmin ||
      this.login.userType == "secretary" ||
      exam.UID == this.login.doctor
    );
  }

  askDelete(exam) {
    let etime = new Date(exam.CreationTime);
    if (this.defaults || !this.examServe.examClosed(etime)) {
      //if the exam is from today alow dele
      this.toDelete = exam;
    }
    return false;
  }

  deleteExam() {
    this.pat.AWLID = this.toDelete.AWLID;
    this.examServe.deleteExam(this.toDelete.AutoIndex, this.toDelete.AWLID);
    if (!this.defaults) {
      for (let i = 0; i < this.pregnancies.length; i++) {
        for (let j = 0; j < this.pregnancies[i]["exams"].length; j++) {
          if (
            this.pregnancies[i]["exams"][j].AutoIndex == this.toDelete.AutoIndex
          ) {
            this.pregnancies[i]["exams"].splice(j, 1);
            break;
          }
        }
      }
      for (let i = 0; i < this.otherExams.length; i++) {
        if (this.otherExams[i].AutoIndex == this.toDelete.AutoIndex) {
          this.otherExams.splice(i, 1);
          break;
        }
      }
    } else {
      this.examServe.getDefaults().subscribe(
        (data) => {
          this.defaults = [];
          for (let i = 0; i < data["length"]; i++)
            this.defaults[data[i]["ExamType"]] = data[i];
        },
        (error) => {
          console.error(error);
        },
      );
    }
    this.toDelete = null;
    this.readydelete = false;
  }

  showClose(pregid: number) {}
  closCalForm(event) {
    if (event == "2" || this.examServe.openNewExam) {
      this.examServe.startExam(
        this.examname,
        this.pat.PID,
        this.pat.ID,
        this.pat.AWLID,
        this.pat.ExamLMP,
        this.examServe.concentForm,
      );
    }
    this.examServe.openNewExam = false;
    this.calendarForm = false;
    this.inform = false;
    if (this.pat.ID != "default") {
      this.resetPregs();
    } else {
      //defaults
      this.examServe.getDefaults().subscribe(
        (data) => {
          this.defaults = [];
          for (let i = 0; i < data["length"]; i++)
            this.defaults[data[i]["ExamType"]] = data[i];
        },
        (error) => {
          console.error(error);
        },
      );
    }
  }

  deleteDefault(ex: string) {
    if (this.defaults[ex]) {
      this.askDelete(this.defaults[ex]);
    }
  }

  getDiagnosis(exam, show = false) {
    var strDiagnosis = "No relevant data";
    if (exam && exam.DiagnosisCodes) {
      var temp = this.ds.BuildList(exam.DiagnosisCodes);
      if (temp.length > 0) {
        strDiagnosis = "";
        for (let i = 0; i < temp.length; i++) {
          strDiagnosis +=
            temp[i][1].split(">")[temp[i][1].split(">").length - 1];
          if (temp.length > 1 && i < temp.length - 1) strDiagnosis += ",";
        }
      }
    } else if (exam && exam.Anomalies && exam.Anomalies != "")
      strDiagnosis = exam.Anomalies;
    if (show && exam["Anomalies"] && exam.Anomalies.length > 15)
      // return 'Read More'
      return exam.Anomalies.split(" ")[0] + "...";
    else return strDiagnosis;
  }
  loadCalendarForm(form) {
    this.calendarForm = true;
    this.selectedForm = form;
  }

  getConcent(exam) {
    var temp = this.examServe.pregnancies.filter(
      (i) => i.AutoIndex == exam.PregIndex,
    );
    if (temp.length > 0) {
      temp = temp[0].forms.filter((i) => i.ExamID == exam.AutoIndex);
    }
    if (temp.length > 0) return temp[0];
    else return false;
  }

  openSendQuestionnaire(pat: any) {
    this.sendQuestionnairePatient = pat;
    this.showSendQuestionnaire = true;
  }

  // AR-24: triggered from Create-New > Letters and Certificates > Send
  // Questionnaire. No ExamType is passed, so the popup preselects nothing
  // and the user picks which questionnaire to send.
  openSendQuestionnaireForPatient() {
    const p = this.pat || ({} as any);
    this.openSendQuestionnaire({ Mobile: p.Mobile, ID: p.ID, PID: p.PID });
  }

  onSendQuestionnaireClosed() {
    this.showSendQuestionnaire = false;
    if (this.pat && this.pat.PID != null) this.resetPregs();
  }

  pregClosed() {
    for (let p of this.pregnancies) {
      if (p.AutoIndex == this.closePreg) p.ClosedDate = new Date();
    }
    this.closePreg = null;
  }
}
